import { Route } from '@angular/router';
import { RenderEngineComponent } from '@app/pages/render-engine/render-engine.component';

export const ARTICLES_ROUTES: Route[] = [
  {
    path: '',
    component: RenderEngineComponent,
  },
  {
    path: 'page/:page',
    component: RenderEngineComponent,
  },
  {
    path: 'category/:category',
    component: RenderEngineComponent,
  },
  {
    path: ':slug',
    component: RenderEngineComponent,
  },
  {
    path: 'category/:category/page/:page',
    component: RenderEngineComponent,
  },
  {
    path: 'tag/:tag',
    component: RenderEngineComponent,
  },
  {
    path: 'tag/:tag/page/:page',
    component: RenderEngineComponent,
  },
];